import { Popover, Portal } from '@ark-ui/react';
import classNames from 'classnames';
import { useState } from 'react';

import ArrowDownIcon from 'assets/icons/arrow_down.svg';

import Text from 'components/BaseHelpers/Text';

import type { OtherCollegeNavigationProps } from '../OtherCollegeNavigation';
import SubNav from './SubNav';

import styles from '../OtherCollegeNavigation.module.scss';

const MobileNav = ({ dropdownLabel, dropdownMenu }: OtherCollegeNavigationProps) => {
  const [open, setOpen] = useState(false);

  return (
    <nav className={classNames(styles.nav, styles['nav--mobile'])}>
      <Popover.Root
        modal
        onOpenChange={({ open }) => {
          setOpen(open);
        }}
      >
        <Popover.Trigger
          className={styles.dropdownLabel}
          aria-label={`Open submenu of ${dropdownLabel}`}
        >
          <Text field={dropdownLabel} />
          <ArrowDownIcon aria-hidden className={styles.labelIcon} />
        </Popover.Trigger>
        <Portal>
          <Popover.Content>
            <Popover.CloseTrigger
              onClick={() => setOpen(false)}
              className={styles.hiddenCloseTrigger}
              aria-label="Close menu"
            />
            <SubNav open={open} {...dropdownMenu} />
          </Popover.Content>
        </Portal>
      </Popover.Root>
    </nav>
  );
};

export default MobileNav;
